<template>
  <div style="display: flex; align-items: center">
    <div>
      <span style="margin-right: 10px; width: 100px"> {{ i18nJS.dal }} </span>
      <datepicker :value="startMonth" @input="startDateSelected($event)"></datepicker>
    </div>
    <div class="ml">
      <span style="margin-right: 10px; width: 100px"> {{ i18nJS.al }} </span>
      <datepicker :value="endMonth" @input="endDateSelected($event)"></datepicker>
    </div>
  </div>
</template>

<script>
import apiConnector from '@/epersonam/apiConnector';
import datepicker from '../../datepicker';

export default {
  name: 'startEndDateFilter',
  props: ['buId', 'index', 'params'],
  components: {
    datepicker,
  },
  data() {
    return {
      range: {},
    };
  },
  mounted() {
    this.$emit('selected', { data_selected: { start_date: this.startMonth, end_date: this.endMonth }, index: this.index });
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
    startMonth() {
      return moment().startOf('month').format(window.i18nJS.time.formats.date_only);
    },
    endMonth() {
      return moment().endOf('month').format(window.i18nJS.time.formats.date_only);
    },
  },
  methods: {
    startDateSelected(e) {
      this.$emit('selected', { data_selected: { start_date: e }, index: this.index });
    },
    endDateSelected(e) {
      this.$emit('selected', { data_selected: { end_date: e }, index: this.index });
    },
  },
};
</script>

<style lang="scss" scoped>
.ml {
  margin-left: 36px;
}
</style>
